var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"qy_column"}},[_c('el-tree',{attrs:{"data":_vm.user.user_type==6 ? _vm.data : _vm.data1,"node-key":"id","default-expanded-keys":[1,2, 3,4,5,6,7,8,9],"props":_vm.defaultProps},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }